const BASE_PATTERNS = {
  der: ['der', 'die', 'das', 'den', 'dem', 'des'],
  ein: ['ein', 'eine', 'einen', 'einem', 'einer', 'eines'],
  kein: ['kein', 'keine', 'keinen', 'keinem', 'keiner', 'keines'],
  mein: ['mein', 'meine', 'meinen', 'meinem', 'meiner', 'meines', 'meins'],
  dein: ['dein', 'deine', 'deinen', 'deinem', 'deiner', 'deines', 'deins'],
  sein: ['sein', 'seine', 'seinen', 'seinem', 'seiner', 'seines', 'seins'],
  ihr: ['ihr', 'ihre', 'ihren', 'ihrem', 'ihrer', 'ihres'],
  unser: ['unser', 'unsere', 'unseren', 'unserem', 'unserer', 'unseres'],
  euer: ['euer', 'eure', 'euren', 'eurem', 'eurer', 'eures'],
  Ihr: ['Ihr', 'Ihre', 'Ihren', 'Ihrem', 'Ihrer', 'Ihres'],
  dieser: ['dieser', 'diese', 'dieses', 'diesen', 'diesem', 'dies'],
  jener: ['jener', 'jene', 'jenes', 'jenen', 'jenem'],
  derjenige: ['derjenige', 'diejenige', 'dasjenige', 'denjenigen', 'demjenigen', 'diejenigen'],
  derselbe: ['derselbe', 'dieselbe', 'dasselbe', 'denselben', 'demselben'],
  welcher: ['welcher', 'welche', 'welches', 'welchen', 'welchem', 'welch'],
  wer: ['wer', 'wen', 'wem', 'wessen'],
  jeder: ['jeder', 'jede', 'jedes', 'jeden', 'jedem'],
  alle: ['alle', 'alles', 'allen', 'aller', 'allem'],
  einige: ['einige', 'einigen', 'einiger', 'einigem', 'einiges'],
  mehrere: ['mehrere', 'mehreren', 'mehrerer', 'mehrerem', 'mehreres'],
  manche: ['manche', 'mancher', 'manches', 'manchen', 'manchem', 'manch'],
  beide: ['beide', 'beiden', 'beides', 'beider'],
  viel: ['viel', 'viele', 'vielen', 'vieler', 'vielem'],
  wenig: ['wenig', 'wenige', 'wenigen', 'weniger'],
  andere: ['andere', 'anderes', 'anderen', 'anderem', 'anderer'],
  solche: ['solche', 'solcher', 'solches', 'solchen', 'solchem', 'solch'],
  sämtliche: ['sämtliche', 'sämtlicher', 'sämtlichen', 'sämtlichem'],
  jegliche: ['jegliche', 'jeglicher', 'jegliches', 'jeglichen', 'jeglichem'],
  ich: ['ich', 'mich', 'mir', 'meiner'],
  du: ['du', 'dich', 'dir', 'deiner'],
  er: ['er', 'ihn', 'ihm', 'seiner'],
  sie: ['sie', 'ihr', 'ihrer','ihn'],
  es: ['es', 'ihm', 'seiner','ihn'],
  wir: ['wir', 'uns', 'unser','unsere'],
  Sie: ['Sie', 'Ihnen', 'Ihrer','Ihrem'],
  sich: ['sich', 'seiner','seinem','seinen','mich','dich','mir'],
  irgendein: ['irgendein', 'irgendeine', 'irgendeinen', 'irgendeinem', 'irgendeiner', 'irgendeines'],
  irgendwelch: ['irgendwelch', 'irgendwelche', 'irgendwelchen', 'irgendwelchem', 'irgendwelcher'],
  jemand: ['jemand', 'jemanden', 'jemandem', 'jemandes'],
  niemand: ['niemand', 'niemanden', 'niemandem', 'niemandes'],
};

const buildDeclensionOptions = () => {
  const options = {};

  Object.entries(BASE_PATTERNS).forEach(([patternKey, forms]) => {
    forms.forEach(form => {
      options[form] = forms;
    });
  });

  return options;
};

export const DECLENSION_OPTIONS = buildDeclensionOptions();